import { ENDPOINTS } from '@philips-emr/hpms-health-insurance-commons';
import { Value } from '@philips-emr/tws-core';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';
import HistoryService from '@philips-emr/tws-core/lib/services/history-service';
import { RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';
import { applicationModuleRegistry, isApplicationModule } from '@philips-emr/tws-foundation';

import { APPLICATION_ROUTES, ROUTE } from '../route';

class Audit {
  addRouteListener(): Function {
    return HistoryService.addListener((path: string) => this.routeChangeLog(path));
  }

  routeChangeLog(path: string): Promise<RequestResponse> {

    if (path.endsWith('/')) {
      path = path.slice(0, -1);
    }

    const routes: { [k: string]: string } = {
      [this.parseRoute(APPLICATION_ROUTES.MY_DATA)]: MessageService.translate('hi.my-data'),
      [this.parseRoute(ROUTE.TECHNICAL_VISIT_FORMS)]: MessageService.translate('hi.technical-visit'),
      [this.parseRoute(ROUTE.TECHNICAL_VISIT_DETAILS)]: MessageService.translate('hi.technical-visit'),
    };

    applicationModuleRegistry.getAll().forEach(module => {
      if (isApplicationModule(module)) {
        routes[this.parseRoute(module.route)] = MessageService.translate(module.name);
      }
    });

    const functionName = routes[this.parseCurrentRoute(path)];

    if (!functionName) {
      //@ts-ignore
      return Promise.resolve();
    }

    const body = {
      path,
      current: functionName,
    };

    return Audit.logAuditFunction(body);
  }

  static logAuditFunction(body: Record<string, Value>): Promise<RequestResponse> {
    return HttpService.post(ENDPOINTS.POST.AUDIT_FUNCTION, {}, { body });
  }

  parseCurrentRoute(route: string): string {
    const regex = /\d+/g;
    return route.replace(regex, '');
  }

  parseRoute(route: string): string {
    const regex = /:\w+/g;
    return route.replace(regex, '');
  }
}

export default Audit;
